// src/components/admin/CreateUserForm.js
import React, { useState } from 'react';
import { auth, db } from '../../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore'; // 🔹 Added serverTimestamp

const CreateUserForm = ({ onUserCreated }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('student');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const userCred = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCred.user; // 🔹 This is 'user'

      // Use 'user.uid' to match the variable above
      await setDoc(doc(db, 'users', user.uid), {
        name: name,
        email: email,
        role: role, // 🔹 Changed from hardcoded 'student' to the state 'role'
        assignedTo: [],
        createdAt: serverTimestamp(),
        lastLoginAt: serverTimestamp()
      });

      alert('✅ User created successfully!');
      
      // Safety check: only call if the prop exists
      if (onUserCreated) onUserCreated();
      
      setName(''); setEmail(''); setPassword(''); setRole('student');
    } catch (err) {
      console.error('❌ Error creating user:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.formContainer}>
      <h3>Create New User</h3>
      <form onSubmit={handleSubmit} style={styles.form}>
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          style={styles.input}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={styles.input}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={styles.input}
        />
        <select value={role} onChange={(e) => setRole(e.target.value)} style={styles.select}>
          <option value="student">Student</option>
          <option value="teacher">Teacher</option>
          <option value="admin">Admin</option>
        </select>
        <button type="submit" disabled={loading} style={styles.button}>
          {loading ? 'Creating...' : 'Create User'}
        </button>
      </form>
      {error && <p style={{ color: '#ef4444', marginTop: '10px' }}>{error}</p>}
    </div>
  );
};

// Quick inline styles to match your admin theme
const styles = {
  formContainer: {
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '12px',
    border: '1px dashed #cbd5e1'
  },
  form: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },
  input: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0'
  },
  select: {
    padding: '8px 12px',
    borderRadius: '6px',
    border: '1px solid #e2e8f0',
    backgroundColor: '#fff'
  },
  button: {
    padding: '8px 16px',
    backgroundColor: '#1e3a8a',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: 'bold'
  }
};

export default CreateUserForm;